define(['underscore',
        'text!./templates/address-details-default.html',
        'text!./templates/address-details-BigToSmall.html',
        'text!./templates/address-details-PostCodeBeforeCity.html'],
    (_, defaultTemplate, bigToSmallTemplate, postCodeBeforeCityTemplate)=> {
        return ['LocaleService', (LocaleService)=> {
            const addressConfig = LocaleService.getAddressConfig();
            let template;

            switch (addressConfig.pcfMode) {
                case 'BigToSmall':
                    template = bigToSmallTemplate;
                    break;
                case 'PostCodeBeforeCity':
                    template = postCodeBeforeCityTemplate;
                    break;
                default:
                    template = defaultTemplate;
                    break;
            }

            return {
                restrict: 'A',
                template,
                scope: {
                    address: '=',
                    allContacts: '=',
                    readonly: '@',
                    addressType: '@',
                    displayCountry: '@',
                    defaultCountryCode: '@',
                    disableZipCode: '=',
                    disableCity: '=',
                    disableState: '=',
                    showLoading: '=',
                    hideFields: '='
                },

                link: (scope, element, attrs)=> {
                    attrs.$observe('readonly', (value)=> {
                        scope.readonly = value === 'true';
                    });

                    const defaultCountryCode = scope.defaultCountryCode || LocaleService.getCountry().code;

                    scope.isVisible = (fieldName)=> {
                        let visible = addressConfig.fieldNames.indexOf(fieldName) >= 0;
                        if (scope.hideFields) {
                            visible = visible && !(_.contains(scope.hideFields, fieldName) || _.contains(_.map(scope.hideFields, (idx)=> {
                                    return `${idx}Kanji`;
                                }), fieldName));
                        }
                        return visible;
                    };

                    function syncAddressData() {
                        if (scope.address.value) {
                            scope.address.country.value = scope.address.country.value || defaultCountryCode;
                        } else {
                            scope.address.value = {
                                country: defaultCountryCode
                            };
                        }
                    }

                    scope.$watch('address.value', syncAddressData);
                }
            };
        }];
    });


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/inputs/AddressDetails.js
 **/